import React from "react";

export default function SurveyTextQuestion({ item, value, onChange }) {
  return (
    <div className="flex flex-col gap-2">
      <textarea
        className="w-full rounded-md border border-slate-300 p-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-slate-500"
        rows={item.rows || 2}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={item.placeholder || "Type your answer here..."}
      />
    </div>
  );
}
